import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/ERF/EU_Regional_Development_Fund_vertical.webp'
import _imports_1 from '@/assets/images/ERF/EL_Regionaalarengu_Fond_vertikaalne.webp'
import _imports_2 from '@/assets/images/ERF/EU_Regional_Development_Fund_horizontal.webp'
import _imports_3 from '@/assets/images/ERF/EL_Regionaalarengu_Fond_horisontaalne.webp'


const _hoisted_1 = ["alt"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = ["alst"]
const _hoisted_4 = ["alt"]

import { getGlobalLocale } from '@/utils/formatters'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ERFLogo',
  props: {
  vertical: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const showEnglishVersion = computed<boolean>(() => {
  return getGlobalLocale() !== 'et'
})

const computedClass = computed<string>(() => {
  return props.vertical ? 'erf-logo--vertical' : 'erf-logo--horizontal'
})

return (_ctx: any,_cache: any) => {
  return (__props.vertical && _unref(showEnglishVersion))
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: _normalizeClass(["erf-logo", _unref(computedClass)]),
        src: _imports_0,
        alt: _ctx.$t('erfLogo.altText')
      }, null, 10, _hoisted_1))
    : (__props.vertical && !_unref(showEnglishVersion))
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: _normalizeClass(["erf-logo", _unref(computedClass)]),
          src: _imports_1,
          alt: _ctx.$t('erfLogo.altText')
        }, null, 10, _hoisted_2))
      : (!__props.vertical && _unref(showEnglishVersion))
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            class: _normalizeClass(["erf-logo", _unref(computedClass)]),
            src: _imports_2,
            alst: _ctx.$t('erfLogo.altText')
          }, null, 10, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 3,
            class: _normalizeClass(["erf-logo", _unref(computedClass)]),
            src: _imports_3,
            alt: _ctx.$t('erfLogo.altText')
          }, null, 10, _hoisted_4))
}
}

})